import React from "react";
import { Row } from "antd";
import PropTypes from "prop-types";
import { AuthWrapper } from "./elements";

const AuthLayout = ({ children }) => {
  return (
    <Row style={{ overflow: "hidden" }}>
      <AuthWrapper>{children}</AuthWrapper>
    </Row>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AuthLayout;
